import * as React from 'react'
// import Select from 'react-select'
import { Link } from 'react-router-dom'
import { IPaymentSourceResponseDTO, IRiderObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import Modal from '../../../ui/Modal'
import FormLabel from 'src/components/ui/form/FormLabel'
import { Button, Input, Select } from '@mobiscroll/react-latest'

export interface IAddFundsModalProps {
  rider: IRiderObject
  currentUserId: string
  history: any
  match: any
  onClose: () => void

  addFunds: (
    riderId: string,
    riderName: string,
    riderEmail: string,
    paymentSourceId: string,
    amount: number,
    currentUserId: string
  ) => Promise<any>
}

interface IAddFundsModalState {
  isSubmitting: boolean
  error: string
  selected: string
  amount: number | undefined
}

class AddFundsModal extends React.Component<IAddFundsModalProps, IAddFundsModalState> {
  constructor(props: IAddFundsModalProps) {
    super(props)

    this.state = {
      isSubmitting: false,
      error: '',
      amount: undefined,
      selected: ''
    }
  }

  public render() {
    //TODO: extract payment dropdown into common component
    const pmethods: Array<{ text: string; value: string }> = []
    if (this.props.rider && this.props.rider.wallet) {
      for (const idx of Object.keys(this.props.rider.wallet.sources)) {
        const pmethod: IPaymentSourceResponseDTO = this.props.rider.wallet.sources[idx]
        pmethods.push({
          text: `${pmethod.last4}- EXP ${pmethod.exp_month}/${pmethod.exp_year}`,
          value: pmethod.id
        })
      }
    }

    const saveText = this.state.isSubmitting ? 'Saving...' : UIMessages.common.addFunds

    const getPaymentMethods = () => {
      if (pmethods.length === 0) {
        return [
          {
            text: 'No Options',
            value: 'No Options',
            disabled: true
          }
        ]
      } else {
        return pmethods
      }
    }

    const getPaymentMethodValue = () => {
      const selectedPMethod = pmethods.find(pm => pm.value === this.state.selected)
      if (selectedPMethod !== undefined) {
        return selectedPMethod.text
      } else {
        return ''
      }
    }

    const onAddFunds = async () => {
      const selectedPMethod = pmethods.find(pm => pm.value === this.state.selected)

      if (!selectedPMethod) {
        this.setState({
          error: 'Please select a payment method.'
        })
        return
      }
      if (!this.state.amount) {
        this.setState({
          error: 'No amount indicated.'
        })
        return
      }
      console.log('selectedPMethod', selectedPMethod)
      this.setState({ isSubmitting: true })
      const result = await this.props.addFunds(
        this.props.rider.id,
        this.props.rider.firstName,
        this.props.rider.email,
        this.state.selected,
        this.state.amount || 0,
        this.props.currentUserId
      )
      if (result.status && result.status >= 400) {
        this.setState({
          isSubmitting: false,
          error: result.data
        })
      } else {
        this.handleCancelClick()
      }
    }

    const onAmountChange = (event: any) => {
      this.setState({
        amount: event.target.value
      })
    }

    const onPaymentMethodChange = (event: any) => {
      if (event.value !== null) {
        this.setState({
          selected: event.value
        })
      }
    }

    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>
              {UIMessages.common.addFundsToWallet}
            </span>
            <div
              style={{
                pointerEvents: this.state.isSubmitting ? 'none' : 'auto',
                opacity: this.state.isSubmitting ? 0.4 : 1.0
              }}
              className='mt1 border-top'
            >
              <div className='mb2 mt2'>
                <Select
                  name='SelectPaymentMethod'
                  value={getPaymentMethodValue()}
                  onChange={onPaymentMethodChange}
                  data={getPaymentMethods()}
                  touchUi={false}
                  theme='ios'
                  themeVariant='light'
                  inputStyle='box'
                  label={UIMessages.common.paymentMethod}
                  labelStyle='floating'
                />
              </div>
              <div>
                {/* <FormLabel>{`${UIMessages.common.amount} in dollars`}</FormLabel> */}
                {this.state.error.length ? <p className='font-red ml1 h6'>{this.state.error}</p> : null}
                <div>
                  <Input
                    type='number'
                    className='mobiscroll-input form'
                    placeholder='0.00'
                    onChange={onAmountChange}
                    value={this.state.amount !== undefined ? `${this.state.amount}` : ''}
                    theme='ios'
                    themeVariant='light'
                    inputStyle='box'
                    label={`${UIMessages.common.amount} in dollars`}
                    labelStyle='floating'
                  />
                </div>
              </div>
              <div className='font-red ml1 h5'>
                <small>Processing fee of 3% will be deducted on the top-up.</small>
              </div>
            </div>
            <div className='flex items-center justify-between mt3'>
              <Button
                type='button'
                ariaLabel='addPaymentMethod'
                onClick={this.handleAddPaymentMethod}
                className='mbsc-clear-btn borderless mr-auto'
              >
                + {UIMessages.common.addPaymentMethod}
              </Button>
              <span>
                <Button
                  type='button'
                  ariaLabel='cancel'
                  onClick={this.handleCancelClick}
                  disabled={this.state.isSubmitting}
                  className='mbsc-clear-btn mr2'
                >
                  {UIMessages.common.cancel}
                </Button>
                <Button
                  type='button'
                  ariaLabel='submit'
                  onClick={onAddFunds}
                  disabled={this.state.isSubmitting}
                  className='mbsc-green-btn'
                >
                  {saveText}
                </Button>
              </span>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleAddPaymentMethod = () => {
    this.props.history.push(this.props.match.url + '/add-card')
  }

  private handleCancelClick = () => {
    this.props.onClose()
  }
}

export default AddFundsModal



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/AddFundsModal.tsx